import {connect} from "react-redux";
import Edges from "./Edges";
import {Dispatch, bindActionCreators} from "redux";
import {
    setSelectedEdges,
    setSelectedPapers
} from "../../store/actions";

const mapStateToProps = (state: any): { state: any } => ({
    state: state,
});

function mapDispatchToProps(dispatch: Dispatch) {
    return {
        setSelectedEdges: bindActionCreators(setSelectedEdges, dispatch),
        setSelectedPapers: bindActionCreators(setSelectedPapers, dispatch),
    };
}

const NodesCon = connect(mapStateToProps, mapDispatchToProps)(Edges);
export default NodesCon;